














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DialogButton } from '@/core/contracts';

@Component
export default class ModalDialog extends Vue {
    @Prop({ type: String, required: true }) public message!: string;
    @Prop({ type: Array, required: true }) public buttons!: DialogButton[];
}
